// Date 2023-12-13 10:13:14

import jscConfiguration from "@/store/emAssistant/jsc/JscConfigurationStore.js";

const genericEntities = [
    'jscConfiguration'
]

const entities = {
    jscConfiguration
}

export {genericEntities}

export default entities
